import fullpage from "fullpage.js/dist/fullpage.extensions.min.js";

var anchorsArr = [];

export default {
    init() {
        $(".section").each(function() {
            anchorsArr.push($(this).data("anchor"));
        });
    },
    finalize() {
        const fullpageArgs = {
            autoScrolling: true,
            navigation: true,
            slidesNavigation: true,
            controlArrows: true,
            slidesNavPosition: 'bottom',
            licenseKey: '9A807746-61564EAE-AEB43D95-AF0FE019',
            responsiveSlidesKey: 'bm92dXMuYWVyb19XME1jbVZ6Y0c5dWMybDJaVk5zYVdSbGN3PT1wdGo=',
            responsiveSlides: true,
            responsiveWidth: 769,
            anchors: anchorsArr,
            onLeave: function(origin, destination){
                if($(destination.item).find(".footer").length < 1) {
                    setTimeout(function() {
                        $(origin.item).removeClass("is-chapter");
                    }, 400);
                }

                if($(destination.item).find(".chapter").length > 0 || $(destination.item).find(".chapter-image").length > 0) {
                    var firstSlide = $(destination.item).children(".fp-slides").children(".fp-slidesContainer:first").children(".fp-slide:first");

                    if(firstSlide.hasClass("active")) {
                        $(destination.item).addClass("is-chapter");
                    }
                }
            },
            onSlideLeave: function(section, origin, destination){
                if(destination.isFirst == false) {
                    $(section.item).removeClass("is-chapter");
                } else {
                    $(section.item).addClass("is-chapter");
                }
            },
        };

        setTimeout(() => {
            //fullpageArgs.paddingTop = $(".novus-sticky-header").height() + "px";
            new fullpage("#fullpage", fullpageArgs);
        }, 300);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/citizenship.js